import { createContext, useContext } from "react";

import type { GanttContextValue } from "./types-gantt";

export const GanttContext = createContext<GanttContextValue | null>(null);

export function useGanttContext(): GanttContextValue {
  const context = useContext(GanttContext);
  if (!context) throw new Error("Gantt.* deve ser usado dentro de Gantt.Root");
  return context;
}
